import {Map, Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import {type Credit} from './model';

export class CreditsState extends Record<{
    isLoading: boolean;
    credits: Map<string, Credit>;
}>({
    isLoading: true,
    credits: Map<string, Credit>(),
}) {}

export default makeReducer<CreditsState>(
    [
        match(Actions.fetch, state => {
            return state.merge({
                isLoading: true,
            });
        }),
        match(Actions.fetchSuccess, (state, {payload}) => {
            return state.merge({
                isLoading: false,
                credits: Map(payload.credits.map(d => [d.creditId, d])),
            });
        }),
        match(Actions.createSuccess, (state, {payload}) => {
            const credit = payload.credit;
            return state.merge({
                credits: state.credits.set(credit.creditId, credit),
            });
        }),
        match(Actions.updateSuccess, (state, {payload}) => {
            const credit = payload.credit;
            return state.merge({
                credits: state.credits.set(credit.creditId, credit),
            });
        }),
        match(Actions.deleteCreditSuccess, (state, {payload}) => {
            const creditId = payload.creditId;
            return state.merge({
                credits: state.credits.remove(creditId),
            });
        }),
    ],
    new CreditsState(),
);
